var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fixdbox"},[_c('div',{staticClass:"left",on:{"click":function($event){return _vm.online_advice()}}}),_c('div',{staticClass:"right",on:{"click":_vm.Botell}})])])}
var staticRenderFns = []

export { render, staticRenderFns }